import { inputs } from "../../../inputs/inputConfigs";

export default timezone => ({
  groups: [
    {
      items: [
        {
          input: { ...inputs.rfqIssueDate, timezone },
          grid: { sx: 12, sm: 6, md: 3 },
        },
        {
          input: { ...inputs.responseDate, timezone },
          grid: { sx: 12, sm: 6, md: 3 },
        },
        {
          input: inputs.rfqUserid,
          grid: { sx: 12, sm: 12, md: 3 },
        },
      ],
    },
  ],
});
